<template>
  <div class="row">
    <div id="contentTop" />

    <div v-if="error" class="col-md-12 card">
      <div class="card-header noprint">
        <h4 class="card-title">Oops!</h4>
      </div>
      <div class="card-content row">
        <p class="col-md-12">Something went wrong loading this verification request. Please try again or report this error.</p>
      </div>
    </div>
    <div v-else-if="notfound" class="col-md-12 card">
      <div class="card-header noprint">
        <h4 class="card-title">Already Resolved</h4>
      </div>
      <div class="card-content row">
        <p class="col-md-12">This verification request has already been resolved and no further action is required at this time.</p>
        <p class="col-md-12">Please close this window.</p>
      </div>
    </div>
    <div v-else-if="resolved" class="col-md-12 card">
      <div class="card-header noprint">
        <h4 class="card-title">Done!</h4>
        <div class="category">Thank you for taking the time to respond to this request. The details of the request and your response are below. You may now close this window.</div>
      </div>
      <div class="card-content row">
        <result 
          :result="'RESOLVED-' + resolvedResult" 
          :notes="newVerification ? newVerification.note : null" 
          :thirdPartyData="verification ? verification.fields['thirdPartyData'] : null"
          :verification="newVerification" /> 
      </div>
    </div>

    <div v-else class="col-md-12 card">
      <div class="card-header noprint">
        <h4 class="card-title">Thank you for taking the time to respond to this request.</h4>
        <div class="category">Please review and resolve the below request for verification.</div>
      </div>
      <div class="card-content row">
        <result 
          result="RESOLVE" 
          :notes="verification ? verification.notes : null" 
          :thirdPartyData="verification ? verification.fields['thirdPartyData'] : null"
          :verification="newVerification" /> 
      </div>
    </div>

    <div 
      v-if="!notfound && !resolved && !error"
      v-loading="loadingVerification"
      element-loading-spinner="qc-spinner" 
      class="col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">Resolution</h4>
        <div class="category">Please supply YOUR details as well as any comments or corrections, and resolve this request with one of the status buttons below.</div>
      </div>
      <div v-if="fullyLoaded" class="form-horizontal">
        <div class="form-group">
          <dynamic-input name="rbName" label="Your name" placeholder="Your name" v-model="rbName" :validations="{required:true}" />
          <dynamic-input name="rbTitle" label="Job title / department" placeholder="Your job title / department" v-model="rbTitle" :validations="{required:true}" />
          <div v-if="this.$store.state.qcAdmin">
            <label class="col-sm-2 control-label">Resolved By Process <span class="text-danger">*</span></label>
            <div class="col-sm-10">
              <el-select v-if="errors.has('selectedAbp')" style="width: 100%" v-model="selectedAbp" name="selectedAbp" v-validate="'required'"
              class="has-error">
              <el-option
              v-for="option in abpOptions"
              :key="option.key"
              :value="option.value"
              :label="option.label"
            ></el-option>
          </el-select>
              <el-select v-else style="width: 100%" v-model="selectedAbp" name="selectedAbp" v-validate="'required'">
                <el-option
                  v-for="option in abpOptions"
                  :key="option.key"
                  :value="option.value"
                  :label="option.label"
                ></el-option>
              </el-select>
              <small class="text-danger" v-if="errors.has('selectedAbp')">
                The Approved By Process field is required
              </small>
            </div>
          </div>
          
          <div class="col-sm-12" style="padding-bottom: 10px">
            <label class="control-label">
              Comments or corrections
            </label>
            <small class="text-danger" v-if="!valid">
              </br>A comment is required for this resolution
            </small>
            <el-input :class="{'has-error': !valid}" type="textarea" :rows="4" placeholder="Comments and corrections" v-model="newVerification.note" />
          </div>
          <div class="col-sm-4">
            <p class="form-control-static text-danger"><button @click.prevent="resolve('VERIFIED')" type="button" class="btn btn-wd btn-fill btn-success"><i class="fa fa-check"></i>&nbsp;Verified</button></p>
            <span class="help-block">This will respond to the enquirer that the above request details combined with corrections and comments made (if any) are correct for the named individual.</span>
          </div>
          <div class="col-sm-4">
            <p class="form-control-static text-danger"><button @click.prevent="resolve('REJECTED')" :disabled="!valid" :class="{'btn-disabled': !valid}" type="button" class="btn btn-wd btn-fill"><i class="fa fa-repeat"></i>&nbsp;Reject</button></p>
            <small class="text-danger" v-if="!valid">A comment is required for this resolution</small>
            <span class="help-block">This will return the request to the enquirer asking them to review and update the request due to issues highlighted in the comments section by yourselves (eg invalid consent form).</span>
          </div>
          <div class="col-sm-4">
            <p class="form-control-static text-danger"><button @click.prevent="resolve('NOT_VERIFIED')" :disabled="!valid" :class="{'btn-disabled': !valid}" type="button" class="btn btn-wd btn-fill btn-danger"><i class="fa fa-times"></i>&nbsp;Not Verified</button></p>
            <small class="text-danger" v-if="!valid">A comment is required for this resolution</small>
            <span class="help-block">This will respond to the enquirer that the above request details are incorrect and there are no corrections or comments that can be made to make them true of any known individual.</span>
          </div>
        </div>
      </div>
    </div>
    <verification-timeline v-if="!public && verification && verification.auditEvents && verification.auditEvents.length != 0" :events="this.verification.auditEvents" />
  </div>
  
</template>

<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import Result from 'src/views/Verifications/components/Result'
  import Verification from 'src/views/Verifications/components/Verification'
  import VerificationTimeLine from 'src/views/Verifications/components/VerificationTimeLine'
  import LogRocket from 'logrocket';
  import { Loading } from 'element-ui'
  
  export default {
    name: "resolve",
    components: {
      DynamicInput,
      Result,
      Verification,
      'verification-timeline': VerificationTimeLine
    },
    props: {
      id: String,
      public: Boolean
    },
    data () {
      return {
        error: false,
        notfound: false,
        resolved: false,
        resolvedResult: null,
        loadingResult: true,
        loadingVerification: true,
        verification: null,
        newVerification: null,
        rbName: null,
        rbTitle: null,
        valid: true,
        abpOptions: [],
        selectedAbp: '',
        verfObj: '',
      }
    },
    mounted: function () {
      if(this.public) {
        this.$store.commit('setPublicToken', this.id)
      }
      this.loadingResult = true
      this.loadingVerification = true
      this.$api.getPendingVerification(this.id, this.public)
        .then(response => {
        if (response.status == 204) {
          this.notfound = true
        } else {
            if (this.$store.state.qcAdmin) {
              this.$api.getApprovedByProcess()
                .then(response => {
                  this.abpOptions = response.data.map((item, index) => {
                    return {
                      key: item + index,
                      value: item,
                      label: item
                    };
                  });
                });
            }
          this.build(response.data)
          }
        })
        .catch(error => {
          console.log(error)
          Sentry.withScope(scope => {
            scope.setExtra('id', this.id)
            scope.setExtra('public', this.public)
            Sentry.captureException(new Error('Failed to load verification for resolve page'))
          }),
          LogRocket.captureException(error, {
            extra: {
              id: this.id,
              public: this.public
            }
          })
          this.error = true
        })
        if(!this.public) {
          this.$api.getAccount()
            .then(response => {
              this.rbName = response.data.firstname + " " + response.data.lastname
              this.rbTitle = response.data.title
            })
        }
      },
      computed: {
        fullyLoaded () {
          return this.verification != null && this.newVerification != null && this.newVerification.institute != null
      },
      note () {
        return this.newVerification ? this.newVerification.note : null
      }
    },
    watch: {
      note (value) {
        if(value) {
          this.valid = true
        }
      }
    },
    methods: {
      build(verification) {
        this.verification = verification
        this.loadingResult = false
        this.$service.buildInstitute(this.verification.instituteId, this.verification)
          .then(response => {
            var builtVerification = this.$service.buildVerification(verification)
            builtVerification.docVerify = verification.docVerify
            builtVerification.institute = response
            this.newVerification = builtVerification
            this.loadingVerification = false
          })
          .catch(error => {
            console.log(error)
            Sentry.withScope(scope => {
              scope.setExtra('id', this.id)
              scope.setExtra('public', this.public)
              Sentry.captureException(new Error('Failed to load institute for resolve page'))
            }),
            LogRocket.captureException(error, {
              extra: {
                id: this.id,
                public: this.public
              }
            })
            this.loadingVerification = false
          })
      },
      resolve (result) {
        this.valid = true
        this.$validator.validate().then(validationResult => {
          if(!this.newVerification.note && (result == 'REJECTED' || result == 'NOT_VERIFIED')) {
            this.valid = false
          } 
          if(validationResult && this.valid) {
              var loading = Loading.service({
                spinner: 'qc-spinner',
                text: 'Resolving verification'
              })
              if(this.$store.state.qcAdmin) {
                this.verfObj = {
                  result: result,
                  notes: this.newVerification.note,
                  approvedByName: this.rbName,
                  approvedByTitle: this.rbTitle,
                  abp: this.selectedAbp
                }
              } else {
                this.verfObj = {
                  result: result,
                  notes: this.newVerification.note,
                  approvedByName: this.rbName,
                  approvedByTitle: this.rbTitle,
                }
              }
              this.$api.resolvePendingVerification(this.verification.id, this.verfObj)
                .then(response => {
                  this.resolvedResult = result
                  if(this.public) {
                    this.resolved = true
                  } else {
                    this.$store.commit('updateMeta')
                    this.$router.push('/verification/pending')
                  }
                  loading.close()
                  this.$el.querySelector('#contentTop').scrollIntoView()
                  this.$snotify.success("Verification resolved, thank you.", "Success")
                })
                .catch(error => {
                  console.log(error)
                  Sentry.withScope(scope => {
                    scope.setExtra('id', this.id)
                    scope.setExtra('public', this.public)
                    Sentry.captureException(new Error('Failed to submit resolution update for resolve page'))
                  }),
                  LogRocket.captureException(error, {
                    extra: {
                      id: this.id,
                      public: this.public
                    }
                  })
                  loading.close()
                })
            } else {
              this.$snotify.error("Please correct the errors shown below.", "Error", {
                timeout: 7500
              })
            }
          })
      }
  }
}
</script>

<style scoped>


.has-error {
  border-color: red;
}







</style>